import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "detailsContainer" }
const _hoisted_2 = { class: "totalValue" }
const _hoisted_3 = { class: "customText" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }

import { PropType, ref, } from 'vue';
import CashBackHistoryCard from './cashBackHistoryCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getBetList, getDayList } from '@/view/components/supportFunction';
import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackWeekDetails',
  props: {
    cashbackTotal: {
        type: Number,
        default: () => 0
    },
    betList: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    type: {
        type: String,
        default: () => ''
    },
    title: String,
    todayDayRewards: {
        type: Object as PropType<any>
    },
    isShowTodayCard: {
        type: Boolean,
        default: () => false
    },
},
  setup(__props) {

const props = __props
const showDetails = ref(false)
const handleDetailsShow = () => {
    showDetails.value = !showDetails.value
}
const hasBetList = computed(() => props.betList && props.betList.length > 0)
const setdayList = (data: any) => getDayList(props.type, data)
const setBetList = () => getBetList(props.betList, props.isShowTodayCard)

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "16" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('activity.cashBackTotal') + " : ") + " ", 1),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(formatCurrency)(__props.cashbackTotal)), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "8" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: handleDetailsShow,
              class: "detailIcon"
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('activity.details')), 1),
              (!showDetails.value)
                ? (_openBlock(), _createBlock(_component_van_icon, {
                    key: 0,
                    name: "arrow-down"
                  }))
                : (_openBlock(), _createBlock(_component_van_icon, {
                    key: 1,
                    name: "arrow-up"
                  }))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (showDetails.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (__props.isShowTodayCard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(CashBackHistoryCard, {
                  createTime: __props.todayDayRewards.date,
                  "total-amount": __props.todayDayRewards.totalAmount,
                  istodayClaimed: __props.istodayClaimed,
                  title: __props.title,
                  "day-list": __props.todayDayRewards.rewards
                }, null, 8, ["createTime", "total-amount", "istodayClaimed", "title", "day-list"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setBetList(), (item, index) => {
            return (_openBlock(), _createBlock(CashBackHistoryCard, {
              key: index,
              createTime: item.lossDate ?? item.createTime,
              title: __props.title,
              "day-count": item.dayCount ?? item.day,
              "activity-status": item.status,
              "total-amount": item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss,
              istodayClaimed: __props.istodayClaimed,
              "available-amount": item.remainGiftAmount ?? item.availableAmount,
              "day-list": setdayList(item.dayRewards)
            }, null, 8, ["createTime", "title", "day-count", "activity-status", "total-amount", "istodayClaimed", "available-amount", "day-list"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})